import ls from 'local-storage'

import * as types from './types'
import state from './state'

export default {
  [types.AUTH] (commit, payload) {
    if (payload.token) {
      ls.set('user', payload)
      ls.set('token', payload.token)
      state.user = payload
      state.token = payload.token
    }
  },
  [types.SIGNOUT] () {
    ls.remove('user')
    ls.remove('token')
    state.user = null
    state.token = null
  },
  [types.STATUS] (commit, payload) {
    if (payload.customer.token) {
      ls.set('user', payload.customer)
      ls.set('token', payload.customer.token)
      state.user = payload.customer
      state.token = payload.customer.token
    }
  },
  [types.UPDATE_CART] (commit, payload) {
    ls.set('cart', payload)
    state.cart = payload
  },
  [types.ORDER_TYPE] (commit, orderType) {
    ls.set('orderType', orderType)
    state.orderType = orderType
  },
  [types.LOCATION] (commit, payload) {
    ls.set('location', payload)
    state.location = payload
  },
  [types.DISCOUNT] (commit, payload) {
    state.discount = {
      code: payload.code,
      amount: payload.discount,
      type: payload.type
    }
  },
  [types.LOADING_ON] () {
    state.isLoading = true
  },
  [types.LOADING_OFF] () {
    state.isLoading = false
  },
  [types.GENERAL_SETTINGS] (commit, payload) {
    if (payload.minimum_for_delivery) {
      state.deliveryCost = payload.delivery_cost
      state.adminFee = payload.admin_fee
      state.discountThreshold = payload.discount_threshold
      state.minimumForDelivery = payload.minimum_for_delivery
      state.websiteAvailability = {
        isOpen: payload.is_open,
        nextOpeningHour: payload.next_opening_hour,
        nextOpeningDay: payload.next_opening_day,
        canTakeOrders: payload.can_take_orders,
        canDoDelivery: payload.can_do_delivery
      }
      if (state.location) {
        state.websiteContacts = {
          email: payload.email,
          phone: payload['phone'],
          address: payload['address']
        }
      }

      state.socials = {
        facebook: payload.facebook,
        instagram: payload.instagram,
        twitter: payload.twitter,
        youtube: payload.youtube
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js